import { render, staticRenderFns } from "./ProfessionalRoles.vue?vue&type=template&id=1b7f5af3&scoped=true&"
import script from "./ProfessionalRoles.vue?vue&type=script&lang=js&"
export * from "./ProfessionalRoles.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalRoles.vue?vue&type=style&index=0&id=1b7f5af3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f5af3",
  null
  
)

export default component.exports